import React from "react";

export default function PortfolioRiskMatrix()
{
    const matrix =
    [
        [
            { value: 2, colour: "#f4c542" },
            { value: 6, colour: "#f39c12" },
            { value: 12, colour: "#e53935" }
        ],
        [
            { value: 4, colour: "#b7d85c" },
            { value: 10, colour: "#f39c12" },
            { value: 22, colour: "#e53935" }
        ],
        [
            { value: 6, colour: "#5cb85c" },
            { value: 9, colour: "#f4c542" },
            { value: 11, colour: "#f39c12" }
        ]
    ];

    const totals =
    [
        {
            severity: "Critical",
            colour: "#e53935",
            value: 12
        },
        {
            severity: "High",
            colour: "#f39c12",
            value: 34
        },
        {
            severity: "Medium",
            colour: "#f4c542",
            value: 21
        },
        {
            severity: "Low",
            colour: "#5cb85c",
            value: 15
        }
    ];

    const axisLabel =
    {
        fontSize: "11px",
        color: "#666",
        fontWeight: 500
    };

    return (

        <div
            style={{
                width: "100%",
                height: "100%",

                display: "flex",
                flexDirection: "column"
            }}
        >

            <div
                style={{
                    fontSize: "12px",
                    fontWeight: 500,

                    textTransform: "uppercase",

                    marginBottom: "16px",

                    color: "#222"
                }}
            >
                PORTFOLIO RISK MATRIX
            </div>

            <div
                style={{
                    flex: 1,

                    display: "flex"
                }}
            >

                {/* Matrix */}

                <div
                    style={{
                        flex: 1,

                        display: "flex",
                        flexDirection: "column"
                    }}
                >

                    <div
                        style={{
                            textAlign: "center",

                            marginBottom: "6px",

                            ...axisLabel
                        }}
                    >
                        IMPACT
                    </div>

                    <div
					style={{
					    display: "grid",

					    gridTemplateColumns:
					        "42px repeat(3, 60px)",

					    gridTemplateRows:
					        "20px repeat(3, 60px)",

					    gap: "3px",

					    justifyContent: "center",

					    alignItems: "center"
					}}
                    >

                        <div></div>

                        <div style={{ ...axisLabel, textAlign: "center" }}>
                            Low
                        </div>

                        <div style={{ ...axisLabel, textAlign: "center" }}>
                            Medium
                        </div>

                        <div style={{ ...axisLabel, textAlign: "center" }}>
                            High
                        </div>

                        <div
                            style={{
                                ...axisLabel,
                                textAlign: "right",
                                paddingRight: "8px"
                            }}
                        >
                            High
                        </div>

                        {
                            matrix[0].map(
                                (
                                    cell,
                                    index
                                ) => (

                                    <div

                                        key={index}

										style={{
										    width: "60px",
										    height: "60px",

										    background: cell.colour,

										    borderRadius: "2px",

										    display: "flex",

										    alignItems: "center",

										    justifyContent: "center",

										    fontWeight: 700,

										    fontSize: "18px",

										    color:
										        cell.colour === "#f4c542" ||
										        cell.colour === "#b7d85c"
										            ? "#333"
										            : "#fff",

										    cursor: "pointer",

										    transition: ".2s"
										}}
                                    >
                                        {cell.value}
                                    </div>

                                ))
                        }

                        <div
                            style={{
                                ...axisLabel,
                                textAlign: "right",
                                paddingRight: "8px"
                            }}
                        >
                            Medium
                        </div>

                        {
                            matrix[1].map(
                                (
                                    cell,
                                    index
                                ) => (

                                    <div

                                        key={index}

										style={{
										    width: "60px",
										    height: "60px",

										    background: cell.colour,

										    borderRadius: "2px",

										    display: "flex",

										    alignItems: "center",

										    justifyContent: "center",

										    fontWeight: 700,

										    fontSize: "18px",

										    color:
										        cell.colour === "#f4c542" ||
										        cell.colour === "#b7d85c"
										            ? "#333"
										            : "#fff",

										    cursor: "pointer",

										    transition: ".2s"
										}}
                                    >
                                        {cell.value}
                                    </div>

                                ))
                        }

                        <div
                            style={{
                                ...axisLabel,
                                textAlign: "right",
                                paddingRight: "8px"
                            }}
                        >
                            Low
                        </div>

                        {
                            matrix[2].map(
                                (
                                    cell,
                                    index
                                ) => (

                                    <div

                                        key={index}

										style={{
										    width: "60px",
										    height: "60px",

										    background: cell.colour,

										    borderRadius: "2px",

										    display: "flex",

										    alignItems: "center",

										    justifyContent: "center",

										    fontWeight: 700,

										    fontSize: "18px",

										    color:
										        cell.colour === "#f4c542" ||
										        cell.colour === "#b7d85c"
										            ? "#333"
										            : "#fff",

										    cursor: "pointer",

										    transition: ".2s"
										}}
                                    >
                                        {cell.value}
                                    </div>

                                ))
                        }

                    </div>

                </div>

                {/* Totals */}

                <div
                    style={{
                        width: "120px",

                        paddingLeft: "18px",

                        display: "flex",

                        flexDirection: "column",

                        justifyContent: "center"
                    }}
                >

                    {
                        totals.map(
                            (
                                row,
                                index
                            ) => (

                                <div

                                    key={index}

                                    style={{
                                        display: "flex",

                                        alignItems: "center",

                                        marginBottom: "18px"
                                    }}
                                >

                                    <div
                                        style={{
                                            width: "10px",
                                            height: "10px",

                                            borderRadius: "50%",

                                            background:
                                                row.colour,

                                            marginRight: "10px"
                                        }}
                                    />

                                    <div
                                        style={{
                                            flex: 1,

                                            fontSize: "13px",

                                            color: "#444"
                                        }}
                                    >
                                        {row.severity}
                                    </div>

                                   

                                </div>

                            ))
                    }

                </div>

            </div>

        </div>

    );

}